import { render, staticRenderFns } from "./ContentCarousel.vue?vue&type=template&id=3af51852&"
import script from "./ContentCarousel.vue?vue&type=script&lang=js&"
export * from "./ContentCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoCard: require('/usr/src/app/components/video/VideoCard.vue').default,ArticleCard: require('/usr/src/app/components/article/ArticleCard.vue').default})
